import { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lead } from '../../hooks/leads/useLeads';
import classes from './LeadTable.module.css';
import { formatNorwegianDate } from '../../utils/dateFormatters';
import { formatNOK } from '../../utils/currencyFormatters';
import { Routes } from '../../enums/Routes';
import { LEAD_STATUS_LABELS } from '../../constants/lead-status';

interface LeadTableProps {
  leads: Lead[];
}

export const LeadTable = ({ leads }: LeadTableProps): ReactElement => {
  const navigate = useNavigate();

  const handleRowClick = (leadId: number) => {
    navigate(Routes.PartnerAdminLeadDetail.replace(':leadId', String(leadId)));
  };

  return (
    <div className={classes.tableContainer}>
      <table className={classes.table}>
        <thead>
          <tr>
            <th className={classes.qualityColumn}></th>
            <th>Firma</th>
            <th>Kontakt</th>
            <th>Status</th>
            <th>Estimert verdi (mnd)</th>
            <th>Neste oppfølging</th>
          </tr>
        </thead>
        <tbody>
          {leads.map((lead) => {
            return (
              <tr
                key={lead.id}
                onClick={() => handleRowClick(lead.id)}
                className={classes.clickableRow}
              >
                <td className={classes.qualityCell}>
                  {lead.quality && (
                    <div
                      className={`${classes.qualityIndicator} ${classes[`quality${lead.quality}`]}`}
                      title={lead.quality === 'HOT' ? 'Varm' : lead.quality === 'WARM' ? 'Lunken' : 'Kald'}
                    />
                  )}
                </td>
                <td className={classes.nameCell}>
                  <strong>{lead.companyName}</strong>
                </td>
              <td>
                {lead.contactPersonName || lead.contactEmail || '–'}
              </td>
              <td>
                <span className={`${classes.statusBadge} ${classes[`status${lead.status}`]}`}>
                  {LEAD_STATUS_LABELS[lead.status]}
                </span>
                {lead.status === 'WON' && lead.convertedToTenantId === null && (
                  <div className={classes.pendingConversion}>
                    Venter på konvertering
                  </div>
                )}
              </td>
              <td className={classes.valueCell}>
                <div className={classes.valuePrimary}>
                  {formatNOK(lead.estimatedMonthlyValueNOK)}/mnd
                </div>
                <div className={classes.valueSecondary}>
                  Cashback: {formatNOK(lead.estimatedMonthlyCashbackNOK)}/mnd
                </div>
              </td>
              <td>
                {lead.nextFollowUpDate ? (
                  <div>
                    <div>{formatNorwegianDate(lead.nextFollowUpDate)}</div>
                    {lead.daysUntilFollowUp !== null && lead.daysUntilFollowUp < 0 && (
                      <div className={classes.overdue}>
                        {Math.abs(lead.daysUntilFollowUp)} dager forsinket
                      </div>
                    )}
                    {lead.daysUntilFollowUp === 0 && (
                      <div className={classes.today}>I dag!</div>
                    )}
                  </div>
                ) : (
                  <span className={classes.notSet}>Ikke satt</span>
                )}
              </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
